export default __webpack_public_path__ + "static/Siddhant-de8f0494dbe5784d443496b2308746e2.png";